import { gql } from "apollo-boost"

export const UPDATE_BENEFICIARIES_F21 = gql`
  mutation ParticipantsForm(
    $data: [SaveDataInput!]!
  ) {
    SaveParticipantsForm (
      data: $data
    ) {
      id
      ultimateEfficiency
      ultimateEfficiencyJustification
    }
  }
`